export const FETCH_SHOP_DETAIL = "FETCH_SHOP_DETAIL"
export const FETCH_HQ_SHOP_DETAIL = "FETCH_HQ_SHOP_DETAIL"
export const FETCH_SHOP_LIST = "FETCH_SHOP_LIST"


//LINK
export const IS_LINK_INVENTORY = "IS_LINK_INVENTORY"
